import moment from "moment";
class employee {
  constructor(
    empId,
    lastName,
    name,
    file,
    typeDoc,
    numDoc,
    highDate,
    downDate,
    preview,
    tags
  ) {
    this.empId = empId;
    this.file = file;
    this.typeDoc = typeDoc;
    this.numDoc = numDoc;
    this.lastName = lastName;
    this.name = name;
    this.highDate = moment.utc(highDate).format("YYYY-MM-DD");
    this.downDate =
      downDate === null || downDate === undefined
        ? downDate
        : moment.utc(downDate).format("YYYY-MM-DD");
    this.fullName = name + " " + lastName;
    this.formatHighDate = moment.utc(highDate).format("DD-MM-YYYY");
    this.formatDownDate =
      downDate === null || downDate === undefined
        ? downDate
        : moment.utc(downDate).format("DD-MM-YYYY");
    this.preview = preview;
    this.baNoEx = downDate === null ? true : false;
    this.id = empId;
    this.isEnabled =
      downDate !== null &&
      moment.utc(downDate).format("YYYY-MM-DD") <= moment().format("YYYY-MM-DD")
        ? false
        : true;
    this.tags = tags;
  }
  static fromJson({
    empId,
    apellido,
    nombre,
    legajo,
    tdoc,
    ndoc,
    fecAlta,
    fecBaja,
    vistaPrevia,
    etiquetas,
  }) {
    return new employee(
      empId,
      apellido,
      nombre,
      legajo,
      tdoc,
      ndoc,
      fecAlta,
      fecBaja,
      vistaPrevia,
      etiquetas
    );
  }
}
export default employee;
